const SITE_URL = "https://poolmoney.in";
const SITE_NAME = "PoolMoney";
const DEFAULT_IMAGE = `${SITE_URL}/logoMain.png`;

const siteSchemas = [
  {
    type: "script",
    props: { type: "application/ld+json" },
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_NAME,
      legalName: "Pardna Technologies Private Limited",
      url: SITE_URL,
      logo: `${SITE_URL}/logoMain.png`,
      contactPoint: {
        "@type": "ContactPoint",
        email: "admin@poolmoney.in",
        contactType: "customer support",
      },
    }),
  },
  {
    type: "script",
    props: { type: "application/ld+json" },
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "PoolMoney App",
      applicationCategory: "FintechApplication",
      operatingSystem: "Android, iOS",
      description: "Purpose-based savings app to complete wishlists without EMI or credit.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
      },
    }),
  },
];

const PAGE_META = {
  "/": {
    title: "PoolMoney | Smartly Break Travel & Purchase Expenses Into Small Amounts",
    description:
      "Break your travel & purchase expenses into small amounts so daily life stays smooth even after spending. No EMI stress after purchase. No debt trap. Just smarter spending with an extra 10% flat discount — plus buy or book travel from any app or offline store and combine 10% flat discount with all existing offers and discounts there.",
    keywords:
      "PoolMoney, purpose-based savings, savings app, wishlist savings, bank escrow, goal saving, travel savings, bike savings, phone savings, INR savings, not EMI, not NBFC, poolmoney, pool money, poolmoney app, wishlist savings app, purpose based savings,goal based savings anti EMI app, No EMI",
    canonical: SITE_URL,
    robots: "index,follow,max-image-preview:large",
    ogTitle: "PoolMoney | Smartly Break Travel & Purchase Expenses Into Small Amounts",
    ogDescription:
      "Break your travel & purchase expenses into small amounts so daily life stays smooth even after spending. No EMI stress after purchase. No debt trap. Just smarter spending with an extra 10% flat discount — plus buy or book travel from any app or offline store and combine 10% flat discount with all existing offers and discounts there.",
    ogUrl: SITE_URL,
    twitterTitle: "PoolMoney App | Save Smart. Buy Without EMI",
    twitterDescription:
      "Purpose-based savings app for bikes, phones & travel. Pay 10% less. Bank-escrow protected.",
  },
  "/aboutUs": {
    title: "About PoolMoney | SSP for Safer Goal Saving",
    description:
      "Learn how PoolMoney SSP helps you save for big-ticket products with transparency, flexibility, and no EMI stress.",
    keywords:
      "About PoolMoney, SSP, goal saving, savings app, transparency, flexibility, bank escrow, no EMI, no credit, savings journey",
    canonical: `${SITE_URL}/aboutUs/`,
    robots: "index,follow",
    ogTitle: "About PoolMoney | SSP for Safer Goal Saving",
    ogDescription:
      "Learn how PoolMoney SSP helps you save monthly, stay transparent, and avoid EMI, interest, and hidden charges.",
    ogUrl: `${SITE_URL}/aboutUs/`,
    twitterTitle: "About PoolMoney | SSP for Safer Goal Saving",
    twitterDescription:
      "Learn how PoolMoney SSP helps you save monthly, stay transparent, and avoid EMI, interest, and hidden charges.",
  },
  "/meetTheTeam": {
    title: "Meet the Team | PoolMoney",
    description:
      "Meet the founders and team building PoolMoney's goal-based savings experience and product design.",
    keywords:
      "PoolMoney team, founders, engineering team, product team, savings app team, company team, meet the team, poolmoneyteam, Behind Pool Money, Pool Money App",
    canonical: `${SITE_URL}/meetTheTeam/`,
    robots: "index,follow",
    ogTitle: "Meet the Team | PoolMoney",
    ogDescription:
      "Meet the founders and team building PoolMoney's goal-based savings experience and product design.",
    ogUrl: `${SITE_URL}/meetTheTeam/`,
    twitterTitle: "Meet the Team | PoolMoney",
    twitterDescription:
      "Meet the founders and team building PoolMoney's goal-based savings experience and product design.",
  },
  "/contact": {
    title: "Contact PoolMoney | Support and Enquiries",
    description:
      "Get in touch with PoolMoney for support, product enquiries, partnerships, or business conversations, Pool Money Support, Pool Money Contact",
    keywords:
      "Contact PoolMoney, support, enquiries, partnerships, business contact, customer support, email PoolMoney",
    canonical: `${SITE_URL}/contact/`,
    robots: "index,follow",
    ogTitle: "Contact PoolMoney | Support and Enquiries",
    ogDescription:
      "Get in touch with PoolMoney for support, product enquiries, partnerships, or business conversations.",
    ogUrl: `${SITE_URL}/contact/`,
    twitterTitle: "Contact PoolMoney | Support and Enquiries",
    twitterDescription:
      "Get in touch with PoolMoney for support, product enquiries, partnerships, or business conversations.",
  },
  "/careers": {
    title: "Careers at PoolMoney | Work With Us",
    description:
      "Explore career opportunities at PoolMoney and join a team building savings-first financial products.",
    keywords:
      "PoolMoney careers, jobs at PoolMoney, fintech jobs, product jobs, engineering jobs, startup careers, Pool Money Team, Work At Pool Money",
    canonical: `${SITE_URL}/careers/`,
    robots: "index,follow",
    ogTitle: "Careers at PoolMoney | Work With Us",
    ogDescription:
      "Explore career opportunities at PoolMoney and join a team building savings-first financial products.",
    ogUrl: `${SITE_URL}/careers/`,
    twitterTitle: "Careers at PoolMoney | Work With Us",
    twitterDescription:
      "Explore career opportunities at PoolMoney and join a team building savings-first financial products.",
  },
  "/privacyPolicy": {
    title: "Privacy Policy | PoolMoney",
    description:
      "Read how PoolMoney collects, uses, and protects user data within the SSP feature and related services.",
    keywords:
      "Privacy Policy, PoolMoney privacy, data protection, user data, SSP privacy, personal information",
    canonical: `${SITE_URL}/privacyPolicy/`,
    robots: "index,follow",
    ogTitle: "Privacy Policy | PoolMoney",
    ogDescription:
      "Read how PoolMoney collects, uses, and protects user data within the SSP feature and related services.",
    ogUrl: `${SITE_URL}/privacyPolicy/`,
    twitterTitle: "Privacy Policy | PoolMoney",
    twitterDescription:
      "Read how PoolMoney collects, uses, and protects user data within the SSP feature and related services.",
  },
  "/termsAndConditions": {
    title: "Terms & Conditions | PoolMoney",
    description:
      "Review the terms that govern use of PoolMoney, including SSP rules, user rights, and platform responsibilities.",
    keywords:
      "Terms and Conditions, PoolMoney terms, SSP rules, user rights, platform responsibilities",
    canonical: `${SITE_URL}/termsAndConditions/`,
    robots: "index,follow",
    ogTitle: "Terms & Conditions | PoolMoney",
    ogDescription:
      "Review the terms that govern use of PoolMoney, including SSP rules, user rights, and platform responsibilities.",
    ogUrl: `${SITE_URL}/termsAndConditions/`,
    twitterTitle: "Terms & Conditions | PoolMoney",
    twitterDescription:
      "Review the terms that govern use of PoolMoney, including SSP rules, user rights, and platform responsibilities.",
  },
  "/investor": {
    title: "Investor Deck | PoolMoney",
    description:
      "Private investor deck for PoolMoney — the pre-purchase saving layer for Indian commerce.",
    keywords: "",
    canonical: null,
    robots: "noindex,nofollow",
    ogTitle: "Investor Deck | PoolMoney",
    ogDescription:
      "Private investor deck for PoolMoney — the pre-purchase saving layer for Indian commerce.",
    ogUrl: `${SITE_URL}/investor`,
    twitterTitle: "Investor Deck | PoolMoney",
    twitterDescription:
      "Private investor deck for PoolMoney — the pre-purchase saving layer for Indian commerce.",
  },
  "/investment": {
    title: "Investment Deck | PoolMoney",
    description:
      "Full investment deck for PoolMoney — the pre-purchase saving layer for Indian commerce.",
    keywords: "",
    canonical: null,
    robots: "noindex,nofollow",
    ogTitle: "Investment Deck | PoolMoney",
    ogDescription:
      "Full investment deck for PoolMoney — the pre-purchase saving layer for Indian commerce.",
    ogUrl: `${SITE_URL}/investment`,
    twitterTitle: "Investment Deck | PoolMoney",
    twitterDescription:
      "Full investment deck for PoolMoney — the pre-purchase saving layer for Indian commerce.",
  },
  "/refundAndCancellation": {
    title: "Refund and Cancellation Policy | PoolMoney",
    description:
      "Understand how refunds, cancellation, missed payments, and SSP completion work inside PoolMoney.",
    keywords:
      "Refund and cancellation, PoolMoney refund policy, cancellation policy, missed payments, SSP completion",
    canonical: `${SITE_URL}/refundAndCancellation/`,
    robots: "index,follow",
    ogTitle: "Refund and Cancellation Policy | PoolMoney",
    ogDescription:
      "Understand how refunds, cancellation, missed payments, and SSP completion work inside PoolMoney.",
    ogUrl: `${SITE_URL}/refundAndCancellation/`,
    twitterTitle: "Refund and Cancellation Policy | PoolMoney",
    twitterDescription:
      "Understand how refunds, cancellation, missed payments, and SSP completion work inside PoolMoney.",
  },
};

function stripTrailingSlash(pathname) {
  if (!pathname) return "/";
  const clean = pathname.replace(/\/+$/, "");
  return clean || "/";
}

function getBaseMeta(pathname) {
  const cleanPath = stripTrailingSlash(pathname);
  if (cleanPath.startsWith("/me/")) {
    return {
      title: "PoolMoney | Shared Earnings",
      description:
        "View a shared earnings page inside PoolMoney. This page is private and not intended for search indexing.",
      keywords: "",
      canonical: null,
      robots: "noindex,nofollow",
      ogTitle: "PoolMoney | Shared Earnings",
      ogDescription:
        "View a shared earnings page inside PoolMoney. This page is private and not intended for search indexing.",
      ogUrl: `${SITE_URL}${cleanPath}`,
      twitterTitle: "PoolMoney | Shared Earnings",
      twitterDescription:
        "View a shared earnings page inside PoolMoney. This page is private and not intended for search indexing.",
    };
  }

  if (cleanPath.startsWith("/dl")) {
    return {
      title: "PoolMoney | App Download",
      description:
        "Open the PoolMoney app download flow. This page is not meant for search indexing.",
      keywords: "",
      canonical: null,
      robots: "noindex,nofollow",
      ogTitle: "PoolMoney | App Download",
      ogDescription:
        "Open the PoolMoney app download flow. This page is not meant for search indexing.",
      ogUrl: `${SITE_URL}${cleanPath}`,
      twitterTitle: "PoolMoney | App Download",
      twitterDescription:
        "Open the PoolMoney app download flow. This page is not meant for search indexing.",
    };
  }

  return PAGE_META[cleanPath] || {
    title: "Page Not Found | PoolMoney",
    description:
      "The page you were looking for does not exist on PoolMoney.",
    keywords: "",
    canonical: null,
    robots: "noindex,follow",
    ogTitle: "Page Not Found | PoolMoney",
    ogDescription:
      "The page you were looking for does not exist on PoolMoney.",
    ogUrl: `${SITE_URL}${cleanPath}`,
    twitterTitle: "Page Not Found | PoolMoney",
    twitterDescription:
      "The page you were looking for does not exist on PoolMoney.",
  };
}

function buildElements(meta) {
  return [
    {
      type: "meta",
      props: { name: "description", content: meta.description },
    },
    ...(meta.keywords
      ? [
          {
            type: "meta",
            props: { name: "keywords", content: meta.keywords },
          },
        ]
      : []),
    {
      type: "meta",
      props: { name: "robots", content: meta.robots },
    },
    {
      type: "meta",
      props: { property: "og:title", content: meta.ogTitle },
    },
    {
      type: "meta",
      props: { property: "og:description", content: meta.ogDescription },
    },
    {
      type: "meta",
      props: { property: "og:url", content: meta.ogUrl },
    },
    {
      type: "meta",
      props: { property: "og:type", content: "website" },
    },
    {
      type: "meta",
      props: { property: "og:image", content: DEFAULT_IMAGE },
    },
    {
      type: "meta",
      props: { property: "og:site_name", content: SITE_NAME },
    },
    {
      type: "meta",
      props: { name: "twitter:card", content: "summary_large_image" },
    },
    {
      type: "meta",
      props: { name: "twitter:title", content: meta.twitterTitle },
    },
    {
      type: "meta",
      props: { name: "twitter:description", content: meta.twitterDescription },
    },
    {
      type: "meta",
      props: { name: "twitter:image", content: DEFAULT_IMAGE },
    },
    ...siteSchemas,
  ].filter(Boolean).concat(
    meta.canonical
      ? [
          {
            type: "link",
            props: { rel: "canonical", href: meta.canonical },
          },
        ]
      : []
  );
}

export function getSeoForPath(pathname) {
  const meta = getBaseMeta(pathname);
  return {
    lang: "en",
    title: meta.title,
    elements: new Set(buildElements(meta)),
  };
}

export function applySeoToDocument(pathname) {
  if (typeof document === "undefined") return;

  const meta = getBaseMeta(pathname);
  document.documentElement.lang = "en";
  document.title = meta.title;

  const upsert = (selector, attrs, tagName = "meta") => {
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement(tagName);
      Object.entries(attrs).forEach(([key, value]) => {
        el.setAttribute(key, value);
      });
      document.head.appendChild(el);
      return;
    }
    Object.entries(attrs).forEach(([key, value]) => {
      el.setAttribute(key, value);
    });
  };

  const remove = (selector) => {
    const el = document.head.querySelector(selector);
    if (el) {
      el.remove();
    }
  };

  upsert('meta[name="description"]', {
    name: "description",
    content: meta.description,
  });
  if (meta.keywords) {
    upsert('meta[name="keywords"]', { name: "keywords", content: meta.keywords });
  } else {
    remove('meta[name="keywords"]');
  }
  upsert('meta[name="robots"]', { name: "robots", content: meta.robots });
  if (meta.canonical) {
    upsert('link[rel="canonical"]', { rel: "canonical", href: meta.canonical }, "link");
  } else {
    remove('link[rel="canonical"]');
  }
  upsert('meta[property="og:title"]', {
    property: "og:title",
    content: meta.ogTitle,
  });
  upsert('meta[property="og:description"]', {
    property: "og:description",
    content: meta.ogDescription,
  });
  upsert('meta[property="og:url"]', { property: "og:url", content: meta.ogUrl });
  upsert('meta[property="og:type"]', { property: "og:type", content: "website" });
  upsert('meta[property="og:image"]', {
    property: "og:image",
    content: DEFAULT_IMAGE,
  });
  upsert('meta[property="og:site_name"]', {
    property: "og:site_name",
    content: SITE_NAME,
  });
  upsert('meta[name="twitter:card"]', {
    name: "twitter:card",
    content: "summary_large_image",
  });
  upsert('meta[name="twitter:title"]', {
    name: "twitter:title",
    content: meta.twitterTitle,
  });
  upsert('meta[name="twitter:description"]', {
    name: "twitter:description",
    content: meta.twitterDescription,
  });
  upsert('meta[name="twitter:image"]', {
    name: "twitter:image",
    content: DEFAULT_IMAGE,
  });
}
